export enum EmailSubType {
  Vt = 'vt',
  Ht = 'ht',
  Phone = 'phone',
  Digital = 'digital',
  Avu = 'avu',
}
